<template>
  <Teleport to="body">
    <div
      v-if="toasts.length > 0"
      class="fixed top-5 right-5 z-50 space-y-3 max-w-xs z-100000"
      role="region"
      aria-label="Notifications"
    >
      <TransitionGroup
        tag="div"
        name="toast-list"
        class="space-y-3"
      >
        <BaseToast
          v-for="toast in toasts"
          :key="toast.id"
          :toast="toast"
          @close="removeToast"
          class="z-100000"
        />
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { useToast } from '@/composables/useToast'
import BaseToast from '../ui/BaseToast.vue'

const { toasts, removeToast } = useToast()
</script>

<style scoped>
.toast-list-enter-active,
.toast-list-leave-active {
  transition: all 0.3s ease;
}

.toast-list-enter-from {
  opacity: 0;
  transform: translateX(100%);
}

.toast-list-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

.toast-list-move {
  transition: transform 0.3s ease;
}
</style> 